'use strict';

angular.module('imagetrend.components')
    .directive('hlpCyberSource', ['$q', '$window', '$filter', '$rootScope', 'Payments', 'Regions', 'Resource', 'Format', '$sce', function ($q, $window, $filter, $rootScope, Payments, Regions, Resource, Format, $sce) {
        return {
            restrict: 'AE',
            scope: {
                licenseRequestId: '@'
            },
            replace: true,
            transclude: true,
            templateUrl: 'templates/cybersource/cybersource.html',
            controller: ['$scope', '$timeout', '$sce', function ($scope, $timeout, $sce) {
                // scope functions
                $scope.signTransaction = function () {
                    if ($scope.submitting == false) {
                        $scope.submitting = true;
                        if ($scope.directPayment) {
                            $scope.copyBilling($scope.directPaymentObject);
                            $scope.directPaymentObject.transaction_license_requests = $scope.checkout_items_ids;
                            $scope.directPaymentObject.payment_method = $scope.payment.merchant_defined_data10;
                            $scope.regions.forEach(function (region) {
                                if (region.id === $scope.directPaymentObject.billing_region_id) {
                                    $scope.directPaymentObject.billing_region_name = region.name;
                                }
                                if (region.id === $scope.directPaymentObject.shipping_region_id) {
                                    $scope.directPaymentObject.shipping_region_name = region.name;
                                }
                            });

                            Payments.directPayment($scope.directPaymentObject).then(function (data) {
                                var transactionID = "";
                                var message = "";

                                if (data != undefined) {
                                    transactionID = data.transactionid;
                                    message = data.message;
                                }

                                if (!$scope.isPortal) {
                                    top.location.href = $rootScope.internalURL + 'license/controller.cfm?method=cnt_transactions.transactionRedirect&message=' + message + '&transactionID=' + transactionID;
                                }
                            });
                        }
                        else {
                            $scope.regions.forEach(function (region) {
                                if (region.id === $scope.payment.billing_region_id) {
                                    $scope.payment.billing_region_name = region.name;
                                }
                                if (region.id === $scope.payment.shipping_region_id) {
                                    $scope.payment.shipping_region_name = region.name;
                                }
                            });
                            $scope.payment.payment_method = 'card';

                            $scope.preSaveCyberSourceObject = {};
                            $scope.preSaveCyberSourceObject.mypayment = $scope.payment;
                            $scope.preSaveCyberSourceObject.mytotals = $scope.totals;
                            $scope.preSaveCyberSourceObject.reponseBaseUrl = $window.location.href;

                            Payments.preSaveCyberSource($scope.preSaveCyberSourceObject).then(function (transactionID) {
                                $scope.payment.reference_number = transactionID;
                                Payments.sign($scope.payment).then(function (signature) {
                                    $scope.signature = signature;
                                    $scope.signed = true;
                                    $scope.submitting = false;
                                });
                            });
                        }
                    }
                }

                $scope.changeMethod = function (method) {
                    $scope.paymentMethods.forEach(function (opt) {
                        if (opt.id == method) {
                            $scope.paymentMethodName = opt.value;
                        }
                    });
                }

                $scope.toggleDirectPayment = function (direct_payment) {
                    if (direct_payment) {
                        $scope.paymentMethods = directPaymentMethods;
                    }
                    else {
                        $scope.paymentMethods = nonDirectPaymentMethods;
                    }
                    $scope.selected_name = '';
                    $scope.payment.payment_method = undefined;
                    $scope.paymentMethodName = "";
                }

                $scope.back = function () {
                    var url = $rootScope.internalURL + 'license/applications/billing/show.cfm?licenseRequestID=' + $scope.licenseRequestId;
                    if ($scope.isPortal) {
                        $window.history.back();
                    }
                    else {
                        $window.location.replace(url);
                    }
                }

                $scope.unsign = function () {
                    $scope.signature = "";
                    $scope.signed = false;
                }

                $scope.columnClick = function (isInspections, predicate) {
                    if (isInspections) {
                        $scope.inspectionPred = predicate;
                        $scope.inspectionRev = !$scope.inspectionRev;
                    }
                    else {
                        $scope.requestPred = predicate;
                        $scope.requestRev = !$scope.requestRev;
                    }
                }

                $scope.checkPaymentType = function (options) {
                    if ($scope.paymentMethodName == undefined || $scope.paymentMethodName == "") { return false; }
                    return options.indexOf($scope.paymentMethodName) >= 0;
                }

                $scope.changeDirect = function (newValue) {
                    if (newValue) {
                        $scope.paymentMethods = $scope.directPaymentMethods;
                    }
                    else {
                        $scope.paymentMethods = $scope.nonDirectPaymentMethods;
                    }
                    $scope.directPayment = newValue;
                    $scope.selected_name = '';
                    $scope.payment.payment_method = undefined;
                }

                $scope.copyBilling = function () {
                    if ($scope.directPaymentObject.same_as_billing) {
                        $scope.directPaymentObject.shipping_street = $scope.directPaymentObject.billing_street;
                        $scope.directPaymentObject.shipping_street_2 = $scope.directPaymentObject.billing_street_2;
                        $scope.directPaymentObject.shipping_municipality = $scope.directPaymentObject.billing_municipality;
                        $scope.directPaymentObject.shipping_region_id = $scope.directPaymentObject.billing_region_id;
                        $scope.directPaymentObject.shipping_postal_code = $scope.directPaymentObject.billing_postal_code;
                    }
                }

            }],
            link: function (scope, elem, attrs, ctrl) {

                // scope variables
                scope.loading = true;
                scope.submitting = false;
                scope.paying = false;
                scope.items = [];
                scope.paymentMethods = [];
                scope.directPaymentMethods = [];
                scope.nonDirectPaymentMethods = [];
                scope.paymentMethodName = "";
                scope.directPayment = false;
                scope.checkingAccountTypes = [];
                scope.regions = [];
                scope.sum_balance_due = 0;
                scope.isPortal = true;
                scope.access_key = "";
                scope.profile_id = "";
                scope.enterpriseWebsite = "";
                scope.enterpriseSiteLocation = "";
                scope.transaction_uuid = guid();
                scope.signed = false;

                if ($rootScope.enterprise) {
                    scope.isPortal = $rootScope.isPortal == "True";
                    scope.enterpriseWebsite = $rootScope.enterprise.website;
                    scope.enterpriseSiteLocation = $rootScope.enterprise.site_location;
                }

                scope.directPaymentObject = {
                    internal: !scope.isPortal,
                    user_id: $rootScope.userID,
                    enterprise_id: $rootScope.enterpriseID,
                    amount: 0
                };

                //the order of these fields is important to the signing which creates the signature in PaymentsController; order must match order in "signed_field_names" property
                scope.payment = {
                    access_key: scope.access_key,
                    profile_id: scope.profile_id,
                    transaction_uuid: scope.transaction_uuid, //used to check for duplicate submissions on their end
                    signed_field_names: 'access_key,profile_id,transaction_uuid,signed_field_names,unsigned_field_names,signed_date_time,locale,transaction_type,reference_number,amount,currency,payment_method,bill_to_forename,bill_to_surname,bill_to_email,bill_to_address_line1,bill_to_address_city,bill_to_address_state,bill_to_address_country,bill_to_address_postal_code,merchant_defined_data5,merchant_defined_data6,merchant_defined_data7,merchant_defined_data8,merchant_defined_data9,merchant_defined_data10',
                    unsigned_field_names: 'card_type,card_number,card_expiry_date,card_cvn',
                    signed_date_time: Format.cyberSourceDate(new Date()),
                    locale: 'en',
                    transaction_type: 'sale', //authorizes transaction and is immediately submitted for settlement
                    reference_number: '', // gets set to our transaction ID
                    amount: 0,
                    currency: 'USD',
                    payment_method: 'card',
                    bill_to_forename: '',
                    bill_to_surname: '',
                    bill_to_email: '',
                    bill_to_address_line1: '',
                    bill_to_address_city: '',
                    bill_to_address_state: '',
                    bill_to_address_country: '',
                    bill_to_address_postal_code: '',
                    merchant_defined_data5: scope.isPortal, //isPortal true or false
                    merchant_defined_data6: $rootScope.userID, //userID 
                    merchant_defined_data7: $rootScope.enterpriseID, //enterpriseID
                    merchant_defined_data8: scope.enterpriseWebsite, //enterprise.website used for portal redirect
                    merchant_defined_data9: scope.enterpriseSiteLocation, //enterprise.site_location used for internal redirect
                    merchant_defined_data10: '' //payment method
                };
                scope.signature = "";

                scope.unsigned = {
                    card_type: '', //001 Test Data
                    card_number: '', //4111111111111111 Test Data
                    card_expiry_date: '', // 11-2020 Test Data
                    card_cvn: ''
                };
                scope.requestColumns = [
                    { header: 'License', predicate: 'license_name' },
                    { header: 'Amount', predicate: 'balance_due' }
                ];
                scope.requestPred = 'license_name';

                // initial loading
                var init = function () {
                    var promises = [];

                    promises.push(Payments.getAttributes().then(function (attributes) {
                        if (attributes != null) {
                            scope.payment.access_key = attributes.access_key;
                            scope.payment.profile_id = attributes.profile_id;
                            scope.post_location = $sce.trustAsResourceUrl(attributes.post_location);
                            if (attributes.hasOwnProperty('fee_message')) {
                                scope.fee_message = attributes.fee_message;
                            }
                            else {
                                scope.fee_message = "";
                            }
                        }
                    }));

                    promises.push(Payments.getPaymentMethods().then(function (methods) {
                        if (methods != null) {
                            scope.directPaymentMethods = $filter('filter')(methods, { 'direct_payment': true });
                            scope.nonDirectPaymentMethods = $filter('filter')(methods, { 'direct_payment': false });
                            scope.paymentMethods = scope.nonDirectPaymentMethods;
                        }
                    }));

                    promises.push(Payments.GetSessionDataForPayment().then(function (items) {
                        scope.checkout_items_ids = "";
                        scope.bulkPayLicenseData = {};

                        if (items.hasOwnProperty('data')) {
                            if (items["data"].hasOwnProperty('checkout_items_ids')) {

                                scope.checkout_items_ids = items["data"]["checkout_items_ids"].toString();
                                if (scope.checkout_items_ids != null) {

                                    if (items["data"].hasOwnProperty('bulkpaylicensedata') && items["data"]["bulkpaylicensedata"].recordcount > 0) {
                                        var bulkpaylicensedataObj = items["data"]["bulkpaylicensedata"];
                                        scope.totals = [];
                                        scope.payment.amount = 0;

                                        var i;
                                        for (i = 1; i <= bulkpaylicensedataObj.recordcount; i++) {
                                            scope.totals.push(bulkpaylicensedataObj[i]);
                                        }

                                        scope.totals.forEach(function (total) {
                                            scope.payment.amount += parseFloat(total.balance_due);
                                        });

                                        scope.payment.amount = parseFloat(scope.payment.amount).toFixed(2);
                                        scope.directPaymentObject.amount = scope.payment.amount;

                                    } else {

                                        promises.push(Payments.getLicenseRequestTotals(scope.checkout_items_ids).then(function (totals) {
                                            scope.totals = totals ? totals : [];
                                            scope.payment.amount = 0;

                                            scope.totals.forEach(function (total) {
                                                scope.payment.amount += parseFloat(total.balance_due);
                                            });
                                            scope.payment.amount = parseFloat(scope.payment.amount).toFixed(2);
                                            scope.directPaymentObject.amount = scope.payment.amount;
                                        }));
                                    }
                                }
                            }
                        }
                    }));

                    promises.push(Payments.getCheckingAccountTypes().then(function (results) {
                        if (results != null) {
                            scope.checkingAccountTypes = results;
                        }
                    }));

                    promises.push(Regions.GetAbbreviation().then(function (regions) {
                        scope.regions = regions;
                    }));

                    // var i = Transactions.getPaymentProvider();
                    //add a and g
                    $q.all(promises).then(function () {
                        scope.loading = false;
                    }).catch(function (response) {
                        // handle error
                    });
                }
                init();

                scope.cardTypes = [
                    { id: '001', name: 'Visa' },
                    { id: '002', name: 'Mastercard' },
                    { id: '003', name: 'American Express' },
                    { id: '004', name: 'Discover' }
                ];

                scope.countries = [
                    { id: 'US', name: 'United States' },
                    { id: 'CA', name: 'Canada' }
                ];
            }
        };
    }])

    ;